import { render } from "./PinnedMessages.vue?vue&type=template&id=5377869e"
import script from "./PinnedMessages.vue?vue&type=script&lang=js"
export * from "./PinnedMessages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__